import { render, staticRenderFns } from "./NewProductArrival.vue?vue&type=template&id=22f03e14&scoped=true&"
import script from "./NewProductArrival.vue?vue&type=script&lang=js&"
export * from "./NewProductArrival.vue?vue&type=script&lang=js&"
import style0 from "./NewProductArrival.vue?vue&type=style&index=0&id=22f03e14&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f03e14",
  null
  
)

export default component.exports